import { getColorValue } from '../lib/utils';

import type { IconProps } from '.';

export const Website = ({ bgColor = 'illustration-line', fgColor = 'illustration-face', size = 48 }: IconProps) => {
  const bgHsl = getColorValue(bgColor);
  const fgHsl = getColorValue(fgColor);

  return (
    <svg fill="none" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
      <path
        fill={bgHsl}
        d="M61 15.2c-.1-.3-.3-.8-.9-1-.3-.2-1.2-.4-2.3-.5l-.3-2.1c-.2-.4-.4-.9-.9-1.1-2-1-16.9-1-25.6-1h-.2c-26.4 0-26.9 1-27.4 1.8-1.4 3.3-2 23.3-.6 37 0 .3.2.6.4.8.3.3.7.7 3 1l.2 2c0 .2.1.4.4.6.6.7 1.8 1.9 21 1.9h6.8C60 54.1 60.8 53 61 52.4c1.5-2.8 1-34 0-37.3Z"
      />
      <path
        fill={fgHsl}
        d="M31.2 24.5c-16.3 0-25 .4-26.7.8-.1 6.9 0 15.2.7 22.2 1.1.3 6 1.1 25.7 1a233 233 0 0 0 24.5-1.2c.5-2.5.7-13.2.5-22.2-3-.3-11.2-.6-24.6-.6H31Zm.1-2.5c7.5 0 19.4.1 24.6.6a74 74 0 0 0-.7-10c-2-.3-10-.7-24.2-.7h-.2c-15.1 0-23.4.4-25.3.9-.4 1.4-.8 5.2-1 10 2.8-.4 9.6-.8 26.8-.8Z"
      />
      <path
        fill={bgHsl}
        d="M51.5 33.7c-2.8-1.6-14-5.4-16-6H35c-.2.2-.2.5-.2.7a85.3 85.3 0 0 0 7.4 16.3h.2l.2-.1c.7-.6 1.8-4.8 2.4-7.4 6.8-2 6.9-2.5 7-3 0-.2-.2-.4-.4-.5ZM10.2 14.8a2.4 2.4 0 1 0 0 4.8 2.4 2.4 0 0 0 0-4.8Zm6.7 0a2.4 2.4 0 1 0 0 4.8 2.4 2.4 0 0 0 0-4.8Zm6.5 0a2.4 2.4 0 1 0 0 4.8 2.4 2.4 0 0 0 0-4.8Z"
      />
    </svg>
  );
};
